module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    attrs: {
      "id": "mask"
    },
    on: {
      "click": _vm.closeDialog
    }
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("\n          Retype infobit\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('ul', _vm._l((_vm.typeDefs), function(typeDef, type) {
    return _c('li', [_c('label', {
      staticClass: "clickable",
      attrs: {
        "for": typeDef.uri
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.infobitType),
        expression: "infobitType"
      }],
      attrs: {
        "id": typeDef.uri,
        "type": "radio"
      },
      domProps: {
        "value": type,
        "checked": _vm._q(_vm.infobitType, type)
      },
      on: {
        "change": function($event) {
          _vm.infobitType = type
        }
      }
    }), _vm._v("\n                " + _vm._s(typeDef.name) + "\n              ")])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "clickable",
    attrs: {
      "id": "ok"
    },
    on: {
      "click": _vm.buttonHandler
    }
  }, [_c('span', {
    staticClass: "fa fa-fw fa-check"
  }), _vm._v("\n            Ok\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "clickable cancel-button",
    attrs: {
      "id": "cancel"
    },
    on: {
      "click": _vm.buttonHandler
    }
  }, [_c('span', {
    staticClass: "fa fa-fw fa-close"
  }), _vm._v("\n            Cancel\n          ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-226abfa3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/retype-dialog.vue
// module id = 137
// module chunks = 0